import classNames from 'classnames';
import React from 'react';
import { ButtonGroup } from 'react-bootstrap';
import Button from '../../components/Button';

const primaryButtons = [{
  key: 'button1',
  text: 'Button',
  variant: 'primary'
}, {
  key: 'button2',
  text: 'Button',
  iconRight: <i className="fal fa-cog icon-right"></i>,
  variant: 'primary'
}, {
  key: 'button3',
  text: 'Button',
  iconLeft: <i className="fal fa-plus icon-left"></i>,
  variant: 'primary'
}, {
  key: 'button4',
  text: 'Button',
  iconLeft: <i className="fal fa-edit icon-left"></i>,
  iconRight: <i className="fal fa-exclamation-triangle icon-right"></i>,
  variant: 'primary'
}];

const secondaryButtons = [{
  key: 'button1',
  text: 'Button',
  variant: 'secondary'
}, {
  key: 'button2',
  text: 'Button',
  iconRight: <i className="fal fa-cog icon-right"></i>,
  variant: 'secondary'
}, {
  key: 'button3',
  text: 'Button',
  iconLeft: <i className="fal fa-plus icon-left"></i>,
  variant: 'secondary'
}, {
  key: 'button4',
  text: 'Button',
  iconLeft: <i className="fal fa-edit icon-left"></i>,
  iconRight: <i className="fal fa-exclamation-triangle icon-right"></i>,
  variant: 'secondary'
}];

const tertiaryButtons = [{
  key: 'button1',
  text: 'Button',
  variant: 'tertiary'
}, {
  key: 'button2',
  text: 'Button',
  iconRight: <i className="fal fa-cog icon-right"></i>,
  variant: 'tertiary'
}, {
  key: 'button3',
  text: 'Button',
  iconLeft: <i className="fal fa-plus icon-left"></i>,
  variant: 'tertiary'
}, {
  key: 'button4',
  text: 'Button',
  iconLeft: <i className="fal fa-edit icon-left"></i>,
  iconRight: <i className="fal fa-exclamation-triangle icon-right"></i>,
  variant: 'tertiary'
}];

const stateButtons = [{
  key: 'button1',
  text: 'Button',
  variant: 'primary'
}, {
  key: 'button2',
  text: 'Button',
  variant: 'primary',
  className: 'hover',
}, {
  key: 'button3',
  text: 'Button',
  variant: 'primary',
  disabled: true
}, {
  key: 'button4',
  text: 'Button',
  className: 'focus',
  variant: 'primary'
}];

const Buttons = () => (<div className="styles-section row" id="buttons">
  <div className='main-page-title col-sm-12 '>
    <h3>Buttons</h3>
  </div>
  <div className='main-page-title col-sm-12'>
    <h6>Primary Button</h6>
  </div>
  <div className='home-page-content col-sm-12'>
    <ButtonGroup>
      {
        primaryButtons.map(button => (
          <Button key={button.key}
            className={button.className}
            variant={button.variant}
            disabled={button.disabled}>
            {button.iconLeft}
            {button.text}
            {button.iconRight}
          </Button>
        ))
      }
    </ButtonGroup>

  </div>
  <div className='main-page-title col-sm-12'>
    <h6>Secondary Button</h6>
  </div>
  <div className='home-page-content col-sm-12'>
    <ButtonGroup>
      {
        secondaryButtons.map(button => (
          <Button key={button.key}
            className={button.className}
            variant={button.variant}
            disabled={button.disabled}>
            {button.iconLeft}
            {button.text}
            {button.iconRight}
          </Button>
        ))
      }
    </ButtonGroup>
  </div>
  <div className='main-page-title col-sm-12'>
    <h6>Tertiary Button</h6>
  </div>
  <div className='home-page-content col-sm-12'>
    <ButtonGroup>
      {
        tertiaryButtons.map(button => (
          <Button key={button.key}
            className={button.className}
            variant={button.variant}
            disabled={button.disabled}>
            {button.iconLeft}
            {button.text}
            {button.iconRight}
          </Button>
        ))
      }
    </ButtonGroup>
  </div>

  <div className='main-page-title col-sm-12'>
    <h6>States (Default, Hover, Disabled, Focused)</h6>
  </div>
  <div className='home-page-content col-sm-12'>
    <ButtonGroup>
      {
        stateButtons.map(button => (
          <Button key={button.key}
            className={classNames(button.className)}
            variant={button.variant}
            disabled={button.disabled}>
            {button.iconLeft}
            {button.text}
            {button.iconRight}
          </Button>
        ))
      }
    </ButtonGroup>
  </div>

</div>);

export default Buttons;
